<template>
    <div v-if="visible" ref="rootEl" class="welcome-box">
        <div class="welcome-message">
            <h1>RatesAutoTransport</h1>
            <p v-html="$t('bitrixWidget')"></p>
        </div>
        <div class=" welcome-buttons">
            <button @click="close" class="close-btn"><i class="ri-close-line"/></button>
        </div>
        <div class="triangle"></div>
    </div>
</template>

<script setup>

import { onBeforeUnmount, onMounted, ref,nextTick } from 'vue';

const visible = ref(false);
const rootEl = ref(null);
let checkInterval = null;

function showMessage() {
    if (!visible.value) {
        const contenedor = document.createElement('div');
        contenedor.className = 'welcome-box-container';
        Object.assign(contenedor.style, {
            position: 'fixed',
            right: '125px',
            bottom: '52px',
            zIndex: '9999999',
            display: 'block',
            visibility: 'visible'
        });

        document.body.appendChild(contenedor);
        visible.value = true;

        nextTick(() => {
            if (rootEl.value) {
                contenedor.appendChild(rootEl.value);
            }
        });
    }
}

function deleteContainer() {
    const contenedor = document.querySelector('.welcome-box-container');
    contenedor?.remove();
}

function close() {
    visible.value = false;
    deleteContainer();
}

onMounted(() => {
    checkInterval = setInterval(() => {
        const bitrixElement = document.querySelector('.b24-widget-button-block');
        if (bitrixElement) {
            showMessage();
            clearInterval(checkInterval);
        }
    }, 5000)

    setTimeout(() => {
        if (checkInterval) {
            clearInterval(checkInterval);
        }
    }, 30000);
})

onBeforeUnmount(() => {
    if (checkInterval) {
        clearInterval(checkInterval);
    }
    deleteContainer();
})

</script>

<style>
/* Usar estilo global para asegurar que se aplique correctamente */
.welcome-box-container {
    display: block !important;
    visibility: visible !important;
    overflow: visible !important;
    width: auto !important;
    height: auto !important;
    opacity: 1 !important;
}

.triangle {
    position: absolute;
    top: 65%;
    right: -4px;
    transform: translateX(0) rotate(45deg);
    width: 9px;
    height: 9px;
    overflow: hidden;
    background-color: white;

    border-right: 2px solid #fce519;
    border-top: 2px solid #fce519;
}

.welcome-box {
    background-color: #fff;
    color: #333;
    border: 2px solid #fce519;
    border-radius: 15px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    padding: 0px 0px 7px 15px;
    width: auto;
    font: bold "Helvetica Neue",
        Arial,
        Helvetica,
        sans-serif;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    visibility: visible !important;
    opacity: 1 !important;
}

.welcome-buttons {
    display: flex;
    flex-grow: 1;
    justify-content: flex-start;
    align-self: flex-start;
    color: #333;
}

.close-btn {
    background-color: white !important;
    color: #dbdde0 !important;
    border: none;
    cursor: pointer;
    font-size: 16px;
    margin: 5px 5px 0;
    padding: 0;
}

.welcome-message {
    flex-grow: 1;
    margin-right: 20px;
    padding-block: 2px;
}

.welcome-message h1 {
    color: #424956 !important;
    font-size: 14px;
    line-height: 1;
    margin-top: 1rem;
    margin-bottom: 0.5rem;
}

.welcome-message p {
    font-size: 13px;
    margin: 0;
    line-height: 1.2;
}
</style>
